/**
 * Report Status Reducer
 * Manages report generation status across the application
 */

// Action Types
export const SET_REPORT_GENERATING = 'SET_REPORT_GENERATING';
export const CLEAR_REPORT_GENERATING = 'CLEAR_REPORT_GENERATING';
export const UPDATE_REPORT_COUNT = 'UPDATE_REPORT_COUNT';

// Initial State
const initialState = {
	isGenerating: false,
	startTime: null,
	reportParams: null,
	lastReportCount: 0
};

// Reducer
export const reportStatusReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_REPORT_GENERATING:
			return {
				...state,
				isGenerating: true,
				startTime: action.payload.startTime,
				reportParams: action.payload.reportParams,
				lastReportCount: action.payload.lastReportCount || state.lastReportCount
			};
		
		case CLEAR_REPORT_GENERATING:
			return {
				...state,
				isGenerating: false,
				startTime: null,
				reportParams: null
			};
		
		case UPDATE_REPORT_COUNT:
			return {
				...state,
				lastReportCount: action.payload.count
			};
		
		default:
			return state;
	}
};

// Action Creators
export const setReportGenerating = (reportParams, lastReportCount = 0) => ({
	type: SET_REPORT_GENERATING,
	payload: {
		startTime: Date.now(),
		reportParams,
		lastReportCount
	}
});

export const clearReportGenerating = () => ({
	type: CLEAR_REPORT_GENERATING
});

export const updateReportCount = (count) => ({
	type: UPDATE_REPORT_COUNT,
	payload: { count }
});

